import { Errors } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

export interface ForgotPasswordPayload {
  email: string;
}
export const forgotPassword = createAction<ForgotPasswordPayload>('FORGOT_PASSWORD');

export const resetLinkSent = createAction<object>('RESET_LINK_SENT');

export interface ForgotPasswordFailedPayload {
  errorType?: Errors;
}
export const forgotPasswordFailed = createAction<ForgotPasswordFailedPayload>('FORGOT_PASSWORD_FAILED');
